(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyDialogController', CompanyDialogController);

    CompanyDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Company', 'SettingInfo', 'AgreementInfo', 'LocationInfo', 'MetaTag', 'CompanyCustom', 'Marketplace'];

    function CompanyDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, Company, SettingInfo, AgreementInfo, LocationInfo, MetaTag, CompanyCustom, Marketplace) {
        var vm = this;

        vm.company = entity;
        vm.clear = clear;
        vm.save = save;
        vm.allMarketplaces = [];
        // vm.settinginfos = SettingInfo.query();
        // vm.agreementinfos = AgreementInfo.query();
        // vm.locationinfos = LocationInfo.query();
        // vm.metatags = MetaTag.query();
        loadAll();

        // $timeout(function (){
        //     angular.element('.form-group:eq(1)>input').focus();
        // });


        function loadAll() {
            getAllMarketplaces();
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            addMarketplaces();
            if (vm.company.id !== null) {
                CompanyCustom.updateCompanyFieldByAdmin().save(vm.company, onSaveSuccess, onSaveError);
            } else {
                // Company.save(vm.company, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:companyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        function addMarketplaces() {

            vm.company.marketplaces = [];
            angular.forEach(vm.allMarketplaces, function (item) {
                if (item.selected) {
                    vm.company.marketplaces.push(item);
                }

            })
        }

        function getAllMarketplaces() {

            Marketplace.query().$promise.then(function (result) {
                    vm.allMarketplaces = result;
                    makeMarketplacesSelectedOnLoad();
                }
            );
        }

        function makeMarketplacesSelectedOnLoad() {
            if (vm.company.marketplaces && vm.company.marketplaces.length > 0) {
                angular.forEach(vm.company.marketplaces, function (item) {
                    angular.forEach(vm.allMarketplaces, function (allItem) {
                        if (allItem.id == item.id)
                            allItem.selected = true;
                    })

                })

            }
        }

    }
})();
